import httpService from "./httpService";
import utils from "./utils";

export default {
  hieuChinhVanBan(form) {
    return httpService.post("/outgoingDoc/hieuChinhVanBan", form);
  },

  updateTltvbData(id, form) {
    return httpService.post(`/outgoingDoc/${id}/updateTltvbData`, form);
  },

  suaSaiBanHanh(id, form) {
    return httpService.put(`/outgoingDoc/${id}/suaSaiBanHanh`, form);
  },

  lanhDaoEditOutgoingDoc(form) {
    return httpService.post("/outgoingDoc/lanhDaoEditOutgoingDoc", form);
  },
  lanhDaoEditOutgoingDocFromDocVersion(form) {
    return httpService.post("/outgoingDoc/lanhDaoEditOutgoingDocFromDocVersion", form);
  },

  createOutgoingDoc(form) {
    return httpService.post("/outgoingDoc/createOutgoingDoc", form);
  },

  createOutgoingDocByScan(forms) {
    return httpService.post("/outgoingDoc/createOutgoingDocByScan", forms);
  },

  createOutgoingDocKyNgoai(form) {
    return httpService.post("/outgoingDoc/createOutgoingDocKyNgoai", form);
  },
  createOutgoingDocKyNgoaiByScan(forms) {
    return httpService.post("/outgoingDoc/createOutgoingDocKyNgoaiByScan", forms);
  },

  count(usingAdvanceSearch, keyword, form) {
    let params = utils.merge(
      { usingAdvanceSearch: usingAdvanceSearch, keyword: keyword },
      form
    );

    return httpService.get("/outgoingDoc/count", { params: params });
  },

  search(query) {
    return httpService.get("/outgoingDoc/search", {
      params: {
        query: query
      }
    });
  },

  findById(id) {
    return httpService.get(`/outgoingDoc/${id}`);
  },

  findByIdForConfigLD(id) {
    return httpService.get(`/outgoingDoc/forConfigLD/${id}`);
  },

  maskAsRead(id, processId) {
    let params = { docId: id, processId: processId };
    return httpService.post(`/outgoingDoc/maskAsRead`, null, {
      params: params
    });
  },

  listChoBanHanh2(form, pageable) {
    let params = utils.merge(form, utils.initPageableParams(pageable));
    return httpService.get("/outgoingDoc/listChoBanHanh", { params: params });
  },

  findAllVbDiThayDoiTrangThai(pageable) {
    let params = utils.merge(utils.initPageableParams(pageable));
    return httpService.get("/outgoingDoc/findAllVbDiThayDoiTrangThai", { params: params });
  },

  thayDoiTrangThaiBanHanhVeDuThao(docId) {
    return httpService.post("/outgoingDoc/thayDoiTrangThaiBanHanhVeDuThao", {docId: docId})
  },

  timKiemVanBanDi(docCode, docDate) {
    let params = utils.merge(
      {docCode: docCode, docDate: docDate}
    );
    return httpService.get("/outgoingDoc/timKiemVanBanDi", { params: params })
  },

  banHanhVanBan(form) {
    return httpService.post("/outgoingDoc/banHanhVanBan", form);
  },

  ccVanBan(form) {
    return httpService.post("/outgoingDoc/ccVanBan", form);
  },

  thuHoi(id, form) {
    return httpService.put(`/outgoingDoc/${id}/thuHoi`, form);
  },

  thuHoiBanHanh(id, form) {
    return httpService.put(`/vbOutgoingProcess/${id}/thuHoiBanHanh`, form);
  },

  delete(id) {
    return httpService.delete(`/outgoingDoc/${id}`);
  },

  deleteForVanThu(id) {
    return httpService.delete(`/outgoingDoc/deleteForVanThu/${id}`);
  },

  findAllForHcCommandsDocRelation(deptId, keyword, pageable) {
    let params = utils.merge(
      { deptId: deptId, keyword: keyword },
      utils.initPageableParams(pageable)
    );
    return httpService.get("/outgoingDoc/findAllForHcCommandsDocRelation", {
      params: params
    });
  },

  permanentDelete(id) {
    return httpService.delete(`/outgoingDoc/permanentDelete/${id}`);
  },

  restore(id) {
    return httpService.put(`/outgoingDoc/restore/${id}`);
  },

  findAllByAchievement(form, pageable) {
    let params = utils.merge(form, utils.initPageableParams(pageable));
    return httpService.get("/outgoingDoc/findAllByAchievement", {
      params: params
    });
  },

  setBanHanhBanGiay(docId) {
    return httpService.put(`/outgoingDoc/setBanHanhBanGiay/${docId}`)
  },

  setKhongCoFileDinhKem(docId) {
    return httpService.put(`/outgoingDoc/setKhongCoFileDinhKem/${docId}`)
  },

  findbyLockedRoleVT(form, pageable, userDeptRoleId) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      {
        userDeptRoleId: userDeptRoleId
      },
      form
    );
    params = utils.merge(params, pageable);
    return httpService.get("/outgoingDoc/findAllByBlockedRole", {
      params: params
    });

  },

  findByIdForBlockedRole(id, blockedUserId) {
    return httpService.get(`/outgoingDoc/forBlockedRole/${id}`, {
      params: {blockedUserId: blockedUserId}
    });
  },

  findByIdForConfigTHVP(id){
    return httpService.get(`/outgoingDoc/findByIdForRoleTongHopAndVanPhong/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/outgoingDocService.js